import { BlockAccessCodeMappings } from 'app/area/code-mappings/types';
import { objectOfType } from 'app/infrastructure/data/object';

export const caseTypeApplicationId = 1;
export const referenceCodetableId = 38;

export const codeMappingsTranslation = {
  mapping_external_values: 9256,
  add_missing_code: 9257,
  view_all_mappings: 9264,
  copy_to_all: 9263,
  external_value: 9260,
  import_set: 9258,
  file_name: 9259,
  missing_codes_info: 9271,
  no_missing_mappings: 9275,
  include_disabled: 9277,
  no_access_to_code_mappings: 9269,
  no_import: 9274,
  validation_error: 8206,
  must_be_filled_out: 5949,
  cancel: 9268,
  save: 9267,
  cancel_changes: 7558,
  are_you_sure: 7460,
  undo_all: 5792,
  go_back: 7966,
  search: 7345,
  search_hits: 7474,
  manage_options: 8521,
  no_access_to_codetable_administration: 8320,
  changes_saved: 9308,
  selected_value_disabled: 9371
};

export type CodeMappingsTranslation = {
  readonly [T in keyof typeof codeMappingsTranslation]: string
};

export const blockAccessCodeMappings = (
  translation: CodeMappingsTranslation = objectOfType<CodeMappingsTranslation>()
): BlockAccessCodeMappings => ({
  id: codeMappingsTranslation.no_access_to_code_mappings,
  text: translation.no_access_to_code_mappings,
  no_import: codeMappingsTranslation.no_import
});
